(function () {
  var items = document.querySelectorAll('[data-bd-timeline-item]');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (item) {
      item.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25, rootMargin: '0px 0px -60px 0px' }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
})();